"use strict";

var Reflux = require("reflux");

var MultiActionStore = require("app/util/flux/multi-action-store");

function createActions() {
  var actions = Reflux.createActions({
      "define": {},
      "clearSelected": {},
      "toggle": {},
      "reposition": {},
      "setSelectedUsers": {},
      "setDatetime": {},
      "populate": { sync: true }
  });

  return actions;
}

module.exports = MultiActionStore.factory(createActions);



// WEBPACK FOOTER //
// ./app/screens/Activity/actions/schedule-actions.js